// extracted by mini-css-extract-plugin
export default {"deleteButton":"RD1lH4lKN6QymN5NmpxC","icon":"nE7VBLx0N6cy1yOif0pB","editButton":"D54GwvcUUEGIg5kIZrzU"};